/* akk-baeklingur.js: the chapter index follows the reader, and the print
   button appears only when script can act on it. */

(() => {
  'use strict';
  if (window.__akkBookLoaded) return;
  window.__akkBookLoaded = true;

  const links = [...document.querySelectorAll('[data-akk-chapter-link]')];
  const chapters = [...document.querySelectorAll('[data-akk-chapter]')];

  if (links.length && chapters.length && 'IntersectionObserver' in window) {
    const byId = new Map(links.map((link) => [link.getAttribute('href').slice(1), link]));
    const visible = new Map();
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) visible.set(entry.target.id, entry.isIntersecting ? entry.intersectionRatio : 0);
      let best = null;
      for (const chapter of chapters) {
        if ((visible.get(chapter.id) ?? 0) > 0) { best = chapter.id; break; }
      }
      for (const [id, link] of byId) {
        if (id === best) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      }
    }, { rootMargin: '-20% 0px -60% 0px', threshold: [0, 0.1, 0.5] });
    for (const chapter of chapters) observer.observe(chapter);
  }

  for (const button of document.querySelectorAll('[data-akk-print]')) {
    button.hidden = false;
    button.addEventListener('click', () => window.print());
  }
})();
